import type { Component } from 'solid-js'

import { directionList } from '@hvf/contracts'
import { useService } from 'solid-services'
import { useFilters } from '../state/filter'
import { FilterSelect } from './FilterSelect'

export const Position: Component = () => {
  const { filters, setPosition } = useService(useFilters)()

  return (
    <FilterSelect
      label="Position"
      items={directionList}
      selected={filters().position}
      onChange={setPosition}
    />
  )
}
